import React, { useState, useEffect } from 'react';
import './carousel.scss';
import Image from '../Image';

const Carousel = ({data}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [slideDone, setSlideDone] = useState(true);
  const [timeID, setTimeID] = useState(null);
  // let data = [
  //   {
  //     "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  //     "type": "string",
  //     "typeName": "string",
  //     "title": "123",
  //     "picPath": "images/1.jpg",
  //     "url": "https://google.com"
  //   },
  //   {
  //     "id": "3fa85f64-5717-4562-b3fc-2c963f66afa8",
  //     "type": "string",
  //     "typeName": "string",
  //     "title": "123",
  //     "picPath": "images/2.png",
  //     "url": "https://google.com"
  //   },
  //   {
  //     "id": "3fa85f64-5717-4562-b3fc-2c963f66afa9",
  //     "type": "string",
  //     "typeName": "string",
  //     "title": "123",
  //     "picPath": "images/1.jpg",
  //     "url": "https://google.com"
  //   },
  // ]
  useEffect(() => {
    if (slideDone) {
      setSlideDone(false);
      setTimeID(
        setTimeout(() => {
          slideNext();
          setSlideDone(true);
        }, 5000)
      );
    }
  }, [slideDone]);

  const slideNext = () => {
    setActiveIndex((val) => {
      if (val >= data.length - 1) {
        return 0;
      } else {
        return val + 1;
      }
    });
  };
  const slidePrev = () => {
    setActiveIndex((val) => {
      if (val <= 0) {
        return data.length - 1;
      } else {
        return val - 1;
      }
    });
  };
  return (
    <div className='carousel'>
      <div className='container__slider'>
        {
          data.map(d => (
            <div className={"slider__item slider__item-active-" + (activeIndex + 1)}
            onClick={()=>{
              window.open(d.url, '_blank')
            }}
            >
              <img src={d.picPath} alt='' />
            </div>))
        }
      </div>
      <div className='button-group'>
        <button className='left-btn' onClick={slidePrev}  >
          <Image src='/images/icons/chevron_right.svg' svg />
        </button>
        <p> {activeIndex + 1} / {data.length}</p>
        <button onClick={slideNext}>
          <Image src='/images/icons/chevron_right.svg' svg />
        </button>
      </div>
    </div>
  )
}

export default Carousel